import { createSlice, SerializedError } from '@reduxjs/toolkit';

import { Basket, BasketTrackingData } from 'src/types';
import { addItemToBasket, getBasketWithOptions } from './thunks';

export interface BasketState {
  basket: Basket;
  trackingData: BasketTrackingData | null;
  error: SerializedError | null;
}

export const initialState: Readonly<BasketState> = {
  basket: { items: [] },
  trackingData: null,
  error: null,
};

export const { actions, reducer } = createSlice({
  name: 'basket',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addItemToBasket.fulfilled, (state, { payload }) => {
        const {
          data: {
            addItem: { basket, trackingData },
          },
        } = payload;

        state.basket.itemsCount = basket.itemsCount;
        state.basket.itemsTotal = basket.itemsTotal;
        state.trackingData = trackingData;
        state.error = null;
      })
      .addCase(addItemToBasket.rejected, (state, action) => {
        state.error = action.error;
      })
      .addCase(getBasketWithOptions.fulfilled, (state, { payload }) => {
        state.basket.items = payload.data.basket.items;
      });
  },
});
